import cx from 'clsx';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

type Props = {
  className?: string;
  name: string;
  label?: string;
  autoSubmitForm?: string;
  children?: React.ReactNode;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Toggle = ({ className, label, name, autoSubmitForm, children = null }: Props) => {
  const ref = React.useRef<HTMLInputElement>(null);
  const { control } = useFormContext();

  const onChangeHandler = React.useCallback(
    (onChange) => (event) => {
      onChange(event.target.checked);
      if (!autoSubmitForm) return;
      const form = document.querySelector(autoSubmitForm) as HTMLFormElement;
      if (!form) return console.warn(`Input: form with selector ${autoSubmitForm} could not be found.`);
      form.requestSubmit();
    },
    [autoSubmitForm],
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <div className={cx('relative flex w-max flex-col', className)} data-testid="control-input">
          <label className="flex cursor-pointer select-none items-center gap-2">
            {label && <span className="text-grey-label">{label}</span>}
            <div className="relative">
              <input ref={ref} type="checkbox" checked={value} onChange={onChangeHandler(onChange)} className="peer sr-only" />
              <div className="block h-8 w-14 rounded-full bg-[#E5E7EB] peer-checked:bg-sky-400" />
              <div className="dot absolute top-1 left-1 h-6 w-6 rounded-full bg-white transition peer-checked:translate-x-6" />
            </div>
          </label>
          {children}
        </div>
      )}
    />
  );
};
